import type { FaireProductEntity } from "../../entity_types/product";

export const p_t2e8n9jr3v: FaireProductEntity = {
  token: "p_t2e8n9jr3v",
  type: "product",
  name: '(PC) GLASS SUNCATCHER - CHAKRA LOTUS 5.75"DIA.',
  brandToken: "b_b1k03395mh",
  brandName: "Oceanic Linkways Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/6277e5728741bc4e69fe666a3f8df01a093d84e6e18c7181f3097d2d8483632f.jpeg",
  galleryImageUrls: [],
  priceDollars: 5.75,
  description:
    'The Chakra Lotus Glass Suncatcher from Oceanic Linkways Inc is a 5.75" diameter masterpiece that beautifully captures and refracts sunlight. This spiritual stone/crystal product has been expertly crafted to align with your chakras, infusing your home or spa with harmony and balance. As a premier wholesaler with sources in 19 countries, we ensure high-quality products. Decorate your home or spa with this captivating suncatcher.',
  tags: [],
  msrpDollars: 17.25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:32.467Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
